import { IModule, IModuleBuilder } from "app/IModule";
import LoginCallback from "./LoginCallback";
import { UserStateReducer, PermissionReducer } from "./login.reducers";

export default class LoginModule implements IModule {
  build(builder: IModuleBuilder) {
      builder.addRoute("/signin-oidc", LoginCallback);
      builder.addReducer("userState", new UserStateReducer());
      builder.addReducer("userPermissions", new PermissionReducer());
  }
}